<template>
    <div id="htapp" class="clearfix" :style="{ backgroundColor: globalBg }" :class="{ noTabbar: !tabbarShow }">
        <template v-if="!$store.state.errorShow">
            <keep-alive>
                <router-view v-if="this.$route.meta.keepAlive" />
            </keep-alive>
            <tabbar v-show="this.tabbarShow" />
            <router-view v-if="!this.$route.meta.keepAlive" />
            <BackHome></BackHome>
        </template>
        <Error class="has-margin" :type="'error'" v-else></Error>
    </div>
</template>

<script>
    import http from "@/utils/http"
    import Tabbar from "@/views/Tabbar"
    import { mapState } from "vuex"
    import BackHome from "@/components/BackHome"
    import { Toast } from "vant"
    import { fetchRgbColer } from "./utils/commons"
    export default {
        components: {
            Tabbar,
            BackHome,
        },
        computed: {
            ...mapState({
                tabbarShow: state => state.tabbarShow,
                globalBg: state => state.globalBg,
            }),
        },
        data() {
            return {
                themeParams: {},
            }
        },
        created() {
            //history.pushState(null, null, document.URL)
            this.getThemeParams()
        },
        methods: {
            setTheme() {
                // 加载设置字体
                if (localStorage.getItem("sizeNum")) {
                    window.document.documentElement.setAttribute("data-size", localStorage.getItem("sizeNum"))
                } else {
                    window.document.documentElement.setAttribute("data-size", 0)
                    this.$store.commit("updateFont", 0)
                }
                let RGBMainColor = fetchRgbColer(this.themeParams.main_color)
                var styleStr = window.document.documentElement.getAttribute("style").split(";")[0] + ";"
                window.document.documentElement.setAttribute(
                    "style",
                    styleStr +
                        "--main-color: " +
                        this.themeParams.main_color +
                        ";--sub-color: " +
                        this.themeParams.secondary_color +
                        ";--rgb-main-color:" +
                        RGBMainColor[0] +
                        "," +
                        RGBMainColor[1] +
                        "," +
                        RGBMainColor[2] +
                        ";"
                )
            },
            getThemeParams() {
                // // 尝试从缓存获取
                const storage = sessionStorage.getItem("theme-params")
                const params = storage !== "undefined" && storage !== "" ? JSON.parse(storage) : null
                if (params) {
                    this.themeParams = params
                    this.setTheme()
                }
                http.get("/nonlogin/basic/getInfo.htm").then(resp => {
                    if (!resp || resp.code != 200) Toast(`获取模板参数失败`)
                    if (resp.data) {
                        sessionStorage.setItem("theme-params", JSON.stringify(resp.data))
                        this.themeParams = resp.data
                        this.setTheme()
                    }
                })
            },
        },
    }
</script>

<style>
    #htapp {
        position: relative;
        min-height: 100vh;
        padding-bottom: 50px;
        box-sizing: border-box;
        background-color: #f7f7f7;
        overflow: hidden;
    }
    #htapp.noTabbar {
        padding-bottom: 0;
    }
    /* 有导航栏的高度 */
    .content-height {
        height: calc(100% - 50px);
    }
    /* 无导航栏高度 */
    .page-height {
        height: inherit;
    }
    .van-tabs__content {
        height: inherit;
    }
    .empty.has-margin {
        margin-top: 120px;
    }
    .zindex1 {
        z-index: 999999 !important;
    }
</style>
